import { Component, OnInit, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { Router } from '@angular/router';
import { AiService } from 'src/app/business-service/ai/ai.service';
import { GlobalService } from 'src/app/modules/shared/services/global/global.service';
import { ResponseNotificationService } from 'src/app/modules/shared/services/response-notification/response-notification.service';

@Component({
  selector: 'app-tg-itinerary-form',
  templateUrl: './tg-itinerary-form.component.html',
  styleUrls: ['./tg-itinerary-form.component.scss'],
})
export class TgItineraryFormComponent implements OnInit {


  tripDetails: any;
  tripDetailsForm!: FormGroup;

  userPreferences: any;
  preferencesForm!: FormGroup;

  showSpinner: boolean = false;

  constructor(
    private _globalService: GlobalService,
    private _fb: FormBuilder,
    private _router: Router,
    private aiService: AiService,
    private _notificationService: ResponseNotificationService
  ) { }

  ngOnInit(): void {
    this.initilizePreferencesForm();
    this.initializeForm();
  }

  // trip Details start form

  initializeForm() {
    this.tripDetailsForm = this._fb.group({
      startDate: [null],
      days: [0],
      startLocation: [''],
      endLocation: [''],
      noOfGuests: [null]
    });


    let tripDetails = this._globalService.getUserTripDetails();
    if (tripDetails) {
      this.tripDetailsForm.patchValue(tripDetails);
    }
  }

  // trip details form end

  // preference form methods

  initilizePreferencesForm() {
    this.preferencesForm = this._fb.group({
      interests: this._fb.group({
        Spiritual: [false],
        Heritage: [false],
        Nature: [false],
        MedicalAndWellness: [false],
        Crafts: [false],
        Waterfalls: [false],
        Buddhist: [false],
        Sports: [false],
        Knowledge: [false],
      }),
      accessibility: this._fb.group({
        WheelchairFriendly: [false],
        LowWalking: [false],
        SeniorFriendly: [false],
      }),
      foodPreference: this._fb.group({
        VegOnly: [false],
        VegNonVeg: [false],
        Vegan: [false],
      }),
      comfortPreference: this._fb.group({
        AvoidHeat: [false],
        Comfortable: [false],
        Any: [false],
      }),
    });

    const savedPreferences = this._globalService.getUserPreferences();
    if (savedPreferences) {
      this.preferencesForm.patchValue({
        interests: this.arrayToGroupValue(savedPreferences.interests, this.preferencesForm.get('interests')!.value),
        accessibility: this.arrayToGroupValue(savedPreferences.accessibility, this.preferencesForm.get('accessibility')!.value),
        foodPreference: this.arrayToGroupValue(savedPreferences.foodPreference, this.preferencesForm.get('foodPreference')!.value),
        comfortPreference: this.arrayToGroupValue(savedPreferences.comfortPreference, this.preferencesForm.get('comfortPreference')!.value),
      });
    }
  }

  private arrayToGroupValue(selectedKeys: string[], groupValue: { [key: string]: boolean }): { [key: string]: boolean } {
    const result: { [key: string]: boolean } = {};
    Object.keys(groupValue).forEach((key) => {
      result[key] = selectedKeys.includes(key);
    });
    return result;
  }

  // preference form end

  today(): Date {
    let date = new Date();
    date.setHours(0, 0, 0, 0);
    return date;
  }


  // Suggested locations and places data

  locations: any[] = [
    {
      location: 'Hyderabad',
      places: [
        { name: 'Charminar', category: 'fort', duration: '2 Hrs', selected: true },
        { name: 'Golconda Fort', category: 'fort', duration: '2 Hrs', selected: true },
        { name: 'Birla Mandir', category: 'temple', duration: '2 Hrs', selected: true }
      ]
    },
    {
      location: 'Yadagirigutta',
      places: [
        { name: 'Yadagirigutta', category: 'temple', duration: '2 Hrs', selected: true },
        { name: 'Bhongir Fort', category: 'fort', duration: '2 Hrs', selected: true },
        { name: 'Kolanupaka Temples', category: 'temple', duration: '2 Hrs', selected: true }
      ]
    },
    {
      location: 'Basara',
      places: [
        { name: 'GnanaSaraswati Temple', category: 'temple', duration: '2 Hrs', selected: true },
        { name: 'Vyasa Maharshi Temple', category: 'temple', duration: '2 Hrs', selected: true }
      ]
    },
    {
      location: 'Karimnagar',
      places: [
        { name: 'Elgandal Fort', category: 'fort', duration: '2 Hrs', selected: true },
        { name: 'Silver Filigree', category: 'fort', duration: '2 Hrs', selected: true },
        { name: 'Manthani Temples', category: 'temple', duration: '2 Hrs', selected: true },
        { name: 'Ramgiri Fort', category: 'fort', duration: '2 Hrs', selected: true }
      ]
    }
  ];

  togglePlace(place: any) {
    place.selected = !place.selected;
  }

  // Toggle select/unselect all places for a location
  isAllSelected(location: any): boolean {
    if (!location || !location.places || !location.places.length) {
      return false;
    }
    return location.places.every((p: any) => p.selected === true);
  }

  toggleSelectAll(location: any) {
    const selectAll = !this.isAllSelected(location);
    location.places.forEach((p: any) => p.selected = selectAll);
  }

  addLocation() {
    console.log('Add location clicked');
  }

  // End of suggested locations and places data

  onSubmit() {
    let tripDetailsData = this._globalService.getUserTripDetails();
    let preferencesData = this._globalService.getUserPreferences();

    const payLoad: any = {
      days: tripDetailsData.days,
      nights: +tripDetailsData.days - 1,
      destination: ['Hyderabad', 'Yadagirigutta', 'Basara', 'Karimnagar'],
      interests: preferencesData.interests
    }

    console.log(payLoad);

    this.showSpinner = true
    this.aiService.getPiAiGeneratedRouteCraftJson(payLoad).subscribe({
      next: (data) => {
        this.showSpinner = false;
        console.log('AI Service Response:', data);

        const routeCraftData = data.routeItineraryDayWise;
        this._globalService.setAiRouteCraft(routeCraftData);
        this._router.navigate(['/ai-route-craft']);
      },
      error: (error) => {
        this.showSpinner = false;
        console.error('Error from AI Service:', error);
        this._notificationService.showMessage('Error generating itinerary. Please try again later.', true);
        this._globalService.hideLoadingSpinner();
      }
    });
  }

}
